import PropTypes from 'prop-types';
import React from 'react';

import useUrlState from '@dashboard/hooks/useUrlState';
import useTableSort from '@dashboard/hooks/useTableSort';
import { FILTER_OPTIONS } from '@dashboard/lib/subscriptionsConstants';
import { getStatusFromQuery } from '@dashboard/lib/tableHelpers';

import { PaymentsSubscriptionsList } from '@dashboard/scenes/PaymentsSubscriptions';
import CardHeaderTitle from '@dashboard/components/CardHeaderTitle';
import ExportView from '@dashboard/components/ExportView';
import FilterInput from '@dashboard/components/Form/components/FilterInput';
import SearchInput from '@dashboard/components/Form/components/SearchInput';

const PageSubscriptions = ({ page }) => {
  const [query, setParams] = useUrlState();
  const { sorting, onSortingChange, sort } = useTableSort();

  const search = query.search || '';
  const status = getStatusFromQuery(query.status, FILTER_OPTIONS);

  const filter = {
    ...(FILTER_OPTIONS[status].value !== 'all' && {
      status: FILTER_OPTIONS[status].value,
    }),
    page: page._id,
    livemode: true,
  };

  const handleSearchChange = value => setParams({ search: value || undefined });

  const handleStatusChange = key =>
    setParams({
      status: FILTER_OPTIONS[key].value === 'all' ? undefined : FILTER_OPTIONS[key].value,
    });

  return (
    <div className="mb-24">
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 pb-4">
        <CardHeaderTitle variant="page">Subscriptions</CardHeaderTitle>

        <div className="flex flex-wrap items-center gap-2 max-lg:w-full [&>*:first-child]:min-w-0 max-lg:[&>*:first-child]:flex-1 max-lg:[&>*:first-child]:basis-56 max-sm:[&>*:first-child]:basis-full">
          <SearchInput
            onChange={handleSearchChange}
            name="search_customers"
            placeholder="Search by email"
            initialValue={search}
          />

          <FilterInput options={FILTER_OPTIONS} onChange={handleStatusChange} value={status} />

          <ExportView
            collection="subscriptions"
            label="subscriptions"
            filters={{
              ...filter,
              page: page._id,
              sort: JSON.stringify(sort),
            }}
          />
        </div>
      </div>

      <PaymentsSubscriptionsList
        sort={sort}
        search={search}
        filter={filter}
        options={{
          hidePaymentLink: true,
          hidePageType: true,
        }}
        sorting={sorting}
        onSortingChange={onSortingChange}
      />
    </div>
  );
};

PageSubscriptions.propTypes = {
  page: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

export default PageSubscriptions;
